import React from "react";
import './floating.css'

import {Heading,Text,Box,Stack,Icon} from "@chakra-ui/react"
import { BsHeadset,BsEnvelopeAtFill,BsFillPinMapFill } from "react-icons/bs";

function Contact() {

    return<>
        
        <div className='row' style={{marginTop:'1px',marginTop:"90px"}}> 
            <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>    
            <div className='col-12 col-lg-12 col-md-12 col-sm-12' style={{textAlign:"center",color:"var(--crt-3)"}}>
                <Heading as="h2" size="sm" mb={2} mt={4} fontWeight="semibold">We’re just a message away</Heading>
            </div>
            <div className='col-12 col-lg-12 col-md-12 col-sm-12 mt-4 mb-5'>
                <Stack width="full" textAlign={"center"} wrap={"wrap"} 
                    flexDirection={{base:"column",mdTo2xl:"row"}} spacing={10} 
                    justifyContent={"center"} alignItems={"center"}>
                    <Box mb={2} alignContent={"center"} boxShadow={"md"} 
                        borderRadius="md" bg="bg.card" border="1px solid" 
                        borderColor="border.subtle" p={1} pl={10} pr={10} h={"200px"} w={"300px"} fontSize={"sm"} color={"var(--crt-3)"}>
                        
                        <Icon as={BsHeadset} boxSize={"55px"} m={4} color="var(--cr-red-1)" />

                        <Text  fontWeight={"normal"} color={"var(--crt-1)"}>Mobile</Text>
                        <Text>+91 9391460554</Text>
                        <Text>+91 638 153 8658</Text>

                    </Box>
                    <Box mb={2} alignContent={"center"} boxShadow={"md"} 
                        borderRadius="md" bg="bg.card" border="1px solid" 
                        borderColor="border.subtle" p={1} pl={10} pr={10} h={"200px"} w={"300px"} fontSize={"sm"} color={"var(--crt-3)"}>
                        
                        <Icon as={BsEnvelopeAtFill} boxSize={"55px"} m={4} color="var(--cr-red-1)" />

                        <Text  fontWeight={"normal"} color={"var(--crt-1)"}>Email</Text>
                        <Text>support@aelitez.in</Text>
                    </Box>
                    <Box mb={2} alignContent={"center"} boxShadow={"md"} 
                        borderRadius="md" bg="bg.card" border="1px solid" 
                        borderColor="border.subtle" p={1} pl={10} pr={10} h={"200px"} w={"300px"} fontSize={"sm"} color={"var(--crt-3)"}>
                        <Icon as={BsFillPinMapFill} boxSize={"55px"} m={4} color="var(--cr-red-1)" />

                        <Text  fontWeight={"normal"} color={"var(--crt-1)"}>Headquarters</Text>
                        <Text> No. 49A, ABT Road, Karuvampalayam, Tirupur- 641604</Text>
                    </Box>
                </Stack>
            </div>        
        </div>
    </>
}

export default Contact